<div class="container">
  <div class="logo b2a">
    <img class="image" src="/assets/logos/4C_Logo_B2A_Claim2018.svg" alt="Back2Action">
    <p class="subline" >{{'LOGIN.logosubline' | translate}}</p>
  </div>

  <app-module>
    <div>{{ 'CONTINUE.message.part-1' | translate }}</div>
    <div>{{ 'CONTINUE.message.part-2' | translate }}</div>
    <button type="button" mat-raised-button color="accent" routerLink="/login">{{'CONTINUE.login' | translate}}</button>
  </app-module>
</div>

<app-footer></app-footer>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/continue/continue.component.html